"use strict";
exports.__esModule = true;
function assignDefaultEntries(selected, defaultCategories) {
    if (selected && !selected.hasChildren) {
        selected.tags.forEach(function (tag) {
            for (var i = 0; i < defaultCategories.length; i++) {
                var t = tag.split(':');
                if (t.length == 2) {
                    var categoryName = t[0], entryName = t[1];
                    if (categoryName == defaultCategories[i]['CategoryName']) {
                        defaultCategories[i]['selectedEntry'] = entryName;
                        break;
                    }
                }
            }
        });
    }
}
exports.assignDefaultEntries = assignDefaultEntries;
function cleanSelectedEntries(defaultCategories) {
    for (var i = 0; i < defaultCategories.length; i++) {
        if ('selectedEntry' in defaultCategories[i]) {
            delete defaultCategories[i]['selectedEntry'];
        }
    }
}
exports.cleanSelectedEntries = cleanSelectedEntries;
function getNewNodeTags(defaultCategories) {
    var tags = ['all'];
    defaultCategories.forEach(function (cat) {
        if (cat['selectedEntry']) {
            tags.push(cat['CategoryName'] + ":" + cat['selectedEntry']);
        }
    });
    return tags;
}
exports.getNewNodeTags = getNewNodeTags;
//# sourceMappingURL=add-node-modal.logic.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/add-node-modal/add-node-modal.logic.js